export default __webpack_public_path__ + "static/media/coresanscr35it-webfont.d67f2968.woff";